<template>
    <div class="comment-likes">
        <a
            href="#"
            class="comment-likes-count"
            :class="`blog-comment-${commentId}`"
            @click.prevent.stop="showPopover"
            v-if="likesCount > 0"
        >
            <span class="icon-thumbs-up"></span> {{ likesCount }}
        </a>
        <span v-if="!likesCount || likesCount <= 0"
            ><span class="icon-thumbs-up"></span> {{ likesCount }}</span
        >
    </div>
</template>

<script>
export default {
    props: {
        commentId: Number,
        likesCount: Number,
        likes: Array
    },

    mounted() {
        if (this.likesCount > 0) {
            $('.blog-comment-' + this.commentId).popover({
                animation: true,
                container: 'body',
                trigger: 'manual',
                placement: 'top',
                content: this.popoverContent,
                html: true
            });
        }

        $(document).on('click', 'body', function () {
            $('.comment-likes-count').popover('hide');
        });

        $(document).on('click', '.popover', function (e) {
            e.stopPropagation();
        });
    },

    data: function () {
        return {
            //
        };
    },

    computed: {
        url: function () {
            return '/blogg/api/comments/' + this.commentId + '/likes';
        },

        popoverContent: function () {
            var content = '<ul>';
            for (var i = 0; i < this.likes.length; i++) {
                content += '<li><a href="/blogg/' + this.likes[i] + '">' + this.likes[i] + '</a></li>';
            }
            content += '</ul>';
            return content;
        }
    },

    methods: {
        showPopover: function () {
            $('.comment-likes-count')
                .not('.blog-comment-' + this.commentId)
                .popover('hide');
            $('.blog-comment-' + this.commentId).popover('show');
        },

        hidePopover: function () {
            $('.blog-comment-' + this.commentId).popover('hide');
        },

        togglePopover: function () {
            $('.blog-comment-' + this.commentId).popover('toggle');
        }
    }
};
</script>
